module.exports = __webpack_public_path__ + "img/reveal-code.041d694e.svg";